import type { InfoPopupState } from '../shared/infoPopup/infoPopupState';

export type TicketsScreenProps = {
  onInfoClick?: () => void;
  onOpenTasks?: () => void;
  onGoBack?: () => void;
};

export type TicketsScreenState = InfoPopupState;

export type TicketsScreenModel = InfoPopupState & {
  onInfoClick?: () => void;
  onOpenTasks?: () => void;
  onGoBack?: () => void;
};

export function createTicketsScreenModel(
  props: TicketsScreenProps,
  state: TicketsScreenState,
): TicketsScreenModel {
  return {
    infoOpen: state.infoOpen,
    setInfoOpen: state.setInfoOpen,
    onInfoClick: props.onInfoClick,
    onOpenTasks: props.onOpenTasks,
    onGoBack: props.onGoBack,
  };
}
